import type { CalcItem } from '@/types';
import { STORAGE_KEY } from '@/utils/constants';

type StoragePayload = {
	i: boolean;
	c: number[][];
};

const values = ref<StoragePayload>();

export function useCalculatorStorage() {
	const route = useRoute();
	const router = useRouter();
	const storage = useLocalStorage([STORAGE_KEY.calculator]);

	watchEffect(() => {
		storage.storage.value = {
			[STORAGE_KEY.calculator]: JSON.stringify(values.value),
		};
	});

	function _parseValues(v?: string) {
		if (!v) return null;
		const payload = JSON.parse(v) as StoragePayload;

		return {
			isInsure: payload.i,
			items: payload.c.map(([w, h, l, we, count]) => {
				return {
					count,
					width: w,
					height: h,
					length: l,
					weight: we,
					goods: [],
				};
			}),
		};
	}

	function getLocalValues() {
		try {
			const localValues = storage.storage.value;

			return _parseValues(localValues?.calculator ?? '');
		} catch (e) {
			console.error(e);
			return null;
		}
	}

	function getRawValues() {
		try {
			return storage.storage.value?.calculator ?? '';
		} catch (e) {
			console.error(e);
			return null;
		}
	}

	function getQueryValues() {
		try {
			const query = route.query as unknown as { values: string };
			return _parseValues(query.values);
		} catch (e) {
			console.error(e);
			return null;
		}
	}

	function getValues() {
		const queryValues = getQueryValues();
		const localValues = getLocalValues();

		return queryValues ?? localValues;
	}

	async function resetQuery() {
		await router.replace({ query: {}, hash: route.hash });
	}

	function saveValues(isInsure: boolean, items: CalcItem[]) {
		const list = items
			.map((v) => [v.width ?? 0, v.height ?? 0, v.length ?? 0, v.weight ?? 0, v.count ?? 0])
			.filter((v) => v.some((i) => i > 0));

		if (!list.length) return;

		values.value = {
			i: isInsure,
			c: list,
		};
	}

	return { values, getValues, saveValues, getLocalValues, getRawValues, resetQuery };
}
